import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import Results from './Results';
import { SearchCriteria } from './SearchCriteria';
import LoadingSpinner from '../../../../library/SimpleControls/LoadingSpinner';

const Layout = () => {
    const { state, dispatch } = useContext(SmartContext);
    
    return (
        <div className="main flex-1">
            {!state?.data && <LoadingSpinner />}
            {state?.data && <div className="">
                <div className="mb-4">
                    <div className="white-block white-block-notopborderradius p-0 h-100">
                        <div className="p-4 p-md-5">
                            <div className="alumni_statistics">
                                <div className='row g-2'>
                                    <div className='col'>
                                        <h2 className="font-26 font-600 mb-0 pb-4">{state.formConfig?.title}</h2>
                                    </div>
                                </div>
                                <div className="ActiveListings_present">
                                    <SearchCriteria />
                                    <Results />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            {/* </div> */}
            {/* </section> */}
        </div>
    );
};

export default Layout;
